'use client'

import { Section } from '@/components/section'
import { T } from '@/components/t'
import { NeotasteExplanationVideo } from '@/features/marketing-videos/neotaste-explanation-video'
import { cn } from '@/utils/styles/cn'

interface IHomeVideoProps {
    withNudge?: boolean
    titleClassName?: string
}

export const HomeVideo = ({ withNudge = true, titleClassName }: IHomeVideoProps) => {
    return (
        <Section className="flex pt-4 flex-col items-center justify-center">
            <T
                t="home.video.title"
                h2
                className={cn('mb-6 text-[28px] md:text-[40px]', titleClassName)}
            />

            {/* Width overrides align the video with the page container instead of the viewport,
                the aspect ratio keeps the height stable so there is no layout shift */}
            <NeotasteExplanationVideo
                className="min-w-0 w-full max-w-full min-h-0 max-h-none md:min-w-0 md:max-w-full md:min-h-0
                    md:max-h-none mb-8"
            />

            {withNudge && <T t="home.video.nudge" p className="text-center font-semibold" />}
        </Section>
    )
}
